//
// Components
//
import '../Fusion/Component/Molecule/SearchBox/SearchBox'

// Trigger Plausible event
(function () {
    if (getParameterByName('q') && window.plausible) {
        let query = getParameterByName('q');
        plausible('Site Search', {props: {query: query}});
    }
    function getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }
})();
